import * as React from "react";
import {cn} from "@/ReactInit/Scripts/DashboardPage/utils/dashboardHelpers";

interface TabsProps {
  tabs: string[];
  activeTab: string;
  onChange: (tab: string) => void;
  disabled?: boolean
}

const Tabs: React.FC<TabsProps> = ({tabs, activeTab, onChange, disabled}) => {
  const base = cn("border-b-[4px] py-3 transition-all duration-300 shrink-0", !disabled && "has-[button:active]:border-b-2");
  const active = cn(base, "border-[#CA7907]");
  const inactive = cn(base, "border-transparent");
  
  return (
    <>
      <div className="relative">
        <ul
          className="flex flex-row items-stretch gap-4 pr-10 mb-5 overflow-x-scroll border-b flex-nowrap desktop:gap-6 scrollbar-hidden scrollbar-fade-end border-[#CA7907]">
          {tabs.map((tabTitle) => (
            <li
              key={tabTitle}
              className={activeTab === tabTitle ? active : inactive}
            >
              <button
                disabled={disabled}
                onClick={() => {
                  if (disabled) return;
                  onChange(tabTitle)
                }}
                className={cn(
                  disabled && "opacity-50 cursor-not-allowed",
                  activeTab === tabTitle && "font-semibold",
                  "text-lg leading-normal text-black-text focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-red-secondary tablet:text-xl"
                )}
              >
                {tabTitle}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default Tabs;
